/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TrashIcon = /*#__PURE__*/ createSvgIcon(
  'TrashIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 015 15.5v-10h-.25a.728.728 0 01-.534-.214A.72.72 0 014 4.754c0-.21.072-.39.216-.535A.72.72 0 014.75 4H8v-.25c0-.212.072-.39.216-.534A.726.726 0 018.75 3h2.5c.213 0 .39.072.534.216A.726.726 0 0112 3.75V4h3.25c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H15v9.991c0 .423-.147.78-.44 1.072A1.45 1.45 0 0113.5 17h-7zm7-11.5h-7v10h7v-10zM8.746 14c.21 0 .39-.072.535-.216a.72.72 0 00.219-.534v-5.5a.728.728 0 00-.214-.534A.72.72 0 008.754 7a.734.734 0 00-.535.216A.72.72 0 008 7.75v5.5c0 .213.071.39.214.534a.72.72 0 00.532.216zm2.5 0c.21 0 .39-.072.535-.216A.72.72 0 0012 13.25v-5.5a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v5.5c0 .213.072.39.214.534a.72.72 0 00.532.216z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TrashIcon;
